import { render, staticRenderFns } from "./SignatureBox.vue?vue&type=template&id=d555d0b2&"
import script from "./SignatureBox.vue?vue&type=script&lang=js&"
export * from "./SignatureBox.vue?vue&type=script&lang=js&"
import style0 from "./SignatureBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports